
export default {
  name: 'AppFieldError',
  props: {
    message: { type: String, required: true }
  }
};
